module.exports = __webpack_public_path__ + "0cb346babc4a0bba19bccbe3801c3316.woff2";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/fonts/Avenir-Roman.woff2
// module id = 642
// module chunks = 0